<template >
  <div   class="full-page-background">
    <div class="row justify-content-center align-items-center login-top">
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div>
          <img style="width: 35vh;margin-right: 3%;" :src="'../../static/' + loginPhoto" alt />
        </div>
      </div>
      <div class="col-lg-3 p-lg-0">
        <div class="login">
          <img class="log-logo" src="../assets/images/logo-innovare-dark.png" alt />
          <div class="log-text">
            Seja bem-vindo ao sistema de marcação de ponto da InnovareTI.
          </div>
          <form action @submit.prevent="login">
            <div class="form-group">
              <label for="inputEmail">E-mail ou Matrícula</label>
              <input type="text" class="form-control" id="inputEmail" placeholder value="admin@innovareti.com.br"
                v-model="email" />
            </div>
            <div class="form-group mb-5">
              <label for="inputSenha">Senha</label>
              <input type="password" class="form-control" id="inputSenha" placeholder value="innovareti"
                v-model="password" />
              <small id="ajudaSenha" class="form-text text-muted float-right">
                <!-- <a href data-toggle="modal" data-target="#modalSenha">Esqueci minha senha</a> -->
              </small>
            </div>
            <!-- <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="switchLembrar">
              <label class="custom-control-label" for="switchLembrar">Lembrar Senha</label>
            </div> -->
            <button type="submit" class="btn btn-block btn-login">
              Entrar
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      loginPhoto: "welcome.png",
    };
  },
  beforeDestroy() {
    clearInterval(this.colorInterval);
  },
  methods: {
  login() {
    const self = this;
    const api = this.$store.state.api + "login";


    const fd = new FormData();
    fd.append("email", self.email);
    fd.append("password", self.password);
    
    axios
      .post(api, fd)
      .then((response) => {
        self.$store.commit("auth", response.data.access_token);
        self.$router.push({ path: "/" });
      })
      .catch((error) => {
        self.$message("Erro", error.response.data, "error");
      });
  },
},
  
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue